if (!customElements.get('product-quantity-bundle')) {
  customElements.define(
    'product-quantity-bundle',
    class ProductQuantityBundle extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.formId = this.dataset.formId;
        this.perUnit = this.dataset.enablePerUnit === 'true';
        this.perUnitQtyOne = this.dataset.perUnitQtyOne === 'true';

        const vEl = this.querySelector('[data-variants-json]');
        const oEl = this.querySelector('[data-options-json]');
        try {
          this.variants = vEl ? JSON.parse(vEl.textContent) : [];
        } catch (e) {
          this.variants = [];
        }
        this.optionCount = 0;
        try {
          const opts = oEl ? JSON.parse(oEl.textContent) : [];
          this.optionCount = Array.isArray(opts) ? opts.length : 0;
        } catch (e) {
          this.optionCount = 0;
        }

        this.tierRadios = this.querySelectorAll('input[data-tier-qty]');
        this.qtyInput = document.getElementById(`Quantity-${this.sectionId}`);
        this.rowsRoot = this.querySelector('[data-per-unit-rows]');
        this.rows = this.querySelectorAll('[data-unit-row]');

        this._onTier = this.onTierChange.bind(this);
        this.tierRadios.forEach((r) => r.addEventListener('change', this._onTier));
        this.addEventListener('change', this.onSelectChange.bind(this));

        this._onSubmit = this.onFormSubmitCapture.bind(this);
        this._attachAttempts = 0;
        this._attachForm();

        this._unsubVariant =
          typeof subscribe === 'function'
            ? subscribe(PUB_SUB_EVENTS.variantChange, this.onGlobalVariantChange.bind(this))
            : () => {};

        this.onTierChange();
      }

      disconnectedCallback() {
        this.tierRadios.forEach((r) => r.removeEventListener('change', this._onTier));
        const form = document.getElementById(this.formId);
        form?.removeEventListener('submit', this._onSubmit, true);
        this._unsubVariant?.();
      }

      _attachForm() {
        const form = document.getElementById(this.formId);
        if (form) {
          form.addEventListener('submit', this._onSubmit, true);
          return;
        }
        this._attachAttempts += 1;
        if (this._attachAttempts < 120) requestAnimationFrame(() => this._attachForm());
      }

      onGlobalVariantChange({ data: { sectionId, variant } }) {
        if (String(sectionId) !== String(this.sectionId)) return;
        if (!variant || !this.rowsRoot) return;
        const row1 = this.querySelector('[data-unit-row="1"]');
        if (!row1 || row1.hidden) return;
        this.applyVariantToRow(1, variant);
      }

      applyVariantToRow(unitIndex, variant) {
        const row = this.querySelector(`[data-unit-row="${unitIndex}"]`);
        if (!row || !variant) return;
        for (let p = 1; p <= 3; p++) {
          const sel = row.querySelector(`select[data-option-position="${p}"]`);
          if (!sel) break;
          const key = `option${p}`;
          const val = variant[key];
          if (val != null && val !== '') {
            const opt = Array.from(sel.options).find((o) => o.value === val);
            if (opt) sel.value = val;
          }
        }
      }

      getTierQuantity() {
        const r = this.querySelector('input[data-tier-qty]:checked');
        return r ? parseInt(r.value, 10) || 1 : 1;
      }

      onTierChange() {
        const n = this.getTierQuantity();
        if (this.qtyInput) this.qtyInput.value = String(n);

        if (!this.perUnit || !this.rowsRoot) return;

        this.rows.forEach((row) => {
          const idx = parseInt(row.getAttribute('data-unit-row'), 10);
          let show = idx <= n;
          if (!this.perUnitQtyOne && n === 1) show = false;
          row.hidden = !show;
        });

        const anyVisible = Array.from(this.rows).some((row) => !row.hidden);
        this.rowsRoot.hidden = !anyVisible;

        const row1 = this.querySelector('[data-unit-row="1"]');
        if (row1 && !row1.hidden) {
          const vJson = document.querySelector(
            `variant-selects#variant-selects-${this.sectionId} script[data-selected-variant]`
          );
          if (vJson) {
            try {
              const v = JSON.parse(vJson.textContent);
              this.applyVariantToRow(1, v);
            } catch (e) {}
          }
        }

        this.syncPrimaryVariantInput();
      }

      onSelectChange(e) {
        if (!e.target.matches?.('select.product-quantity-bundle__option-select')) return;
        this.syncPrimaryVariantInput();
      }

      readRowSelections(unitIndex) {
        const row = this.querySelector(`[data-unit-row="${unitIndex}"]`);
        if (!row || row.hidden) return null;
        const sels = row.querySelectorAll('select.product-quantity-bundle__option-select');
        if (!sels.length) return null;
        const o = [];
        sels.forEach((s) => o.push(s.value));
        return o;
      }

      findVariantId(selections) {
        if (!selections || !this.variants.length) return null;
        const match = this.variants.find((variant) => {
          if (this.optionCount >= 1 && variant.option1 !== selections[0]) return false;
          if (this.optionCount >= 2 && variant.option2 !== selections[1]) return false;
          if (this.optionCount >= 3 && variant.option3 !== selections[2]) return false;
          return true;
        });
        return match ? match.id : null;
      }

      syncPrimaryVariantInput() {
        const n = this.getTierQuantity();
        const form = document.getElementById(this.formId);
        const idInput = form?.querySelector('input[name="id"]');
        if (!idInput || !this.perUnit || !this.rowsRoot) return;
        if (!this.perUnitQtyOne && n === 1) return;

        const v1 = this.readRowSelections(1);
        if (!v1) return;
        const id = this.findVariantId(v1);
        if (id) {
          idInput.value = String(id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      onFormSubmitCapture(evt) {
        if (!this.perUnit || !this.rowsRoot) return;

        const n = this.getTierQuantity();
        if (!this.perUnitQtyOne && n === 1) return;

        const items = [];
        for (let i = 1; i <= n; i++) {
          const sel = this.readRowSelections(i);
          if (!sel) {
            evt.preventDefault();
            evt.stopImmediatePropagation();
            return;
          }
          const id = this.findVariantId(sel);
          if (!id) {
            evt.preventDefault();
            evt.stopImmediatePropagation();
            return;
          }
          items.push({ id, quantity: 1 });
        }

        if (items.length !== n) {
          evt.preventDefault();
          evt.stopImmediatePropagation();
          return;
        }

        if (items.length <= 1) return;

        evt.preventDefault();
        evt.stopImmediatePropagation();

        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const productFormEl = document.querySelector(`product-form[data-section-id="${this.sectionId}"]`);
        const submitBtn = productFormEl?.querySelector('[type="submit"]');
        const spinner = productFormEl?.querySelector('.loading__spinner');
        let submitFailed = false;

        if (submitBtn?.getAttribute('aria-disabled') === 'true') return;

        submitBtn?.setAttribute('aria-disabled', 'true');
        submitBtn?.classList.add('loading');
        spinner?.classList.remove('hidden');

        const payload = { items };
        if (cart) {
          payload.sections = cart.getSectionsToRender().map((s) => s.id);
          payload.sections_url = window.location.pathname;
        }

        fetch(`${window.routes.cart_add_url}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(payload),
        })
          .then((r) => r.json())
          .then((response) => {
            if (response.status) {
              submitFailed = true;
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-quantity-bundle',
                errors: response.errors || response.description,
                message: response.message,
              });
              if (productFormEl && typeof productFormEl.handleErrorMessage === 'function') {
                productFormEl.handleErrorMessage(response.description);
              }
              return;
            }
            if (!cart) {
              window.location = window.routes.cart_url;
              return;
            }
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-quantity-bundle',
              cartData: response,
            }).then(() => {
              cart.renderContents(response);
            });
          })
          .catch((e) => {
            submitFailed = true;
            console.error(e);
          })
          .finally(() => {
            submitBtn?.classList.remove('loading');
            if (!submitFailed) submitBtn?.removeAttribute('aria-disabled');
            spinner?.classList.add('hidden');
          });
      }
    }
  );
}
